import { render, staticRenderFns } from "./PantallaA.vue?vue&type=template&id=5fb9ce7b&scoped=true"
import script from "./PantallaA.vue?vue&type=script&lang=js"
export * from "./PantallaA.vue?vue&type=script&lang=js"
import style0 from "./PantallaA.vue?vue&type=style&index=0&id=5fb9ce7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb9ce7b",
  null
  
)

export default component.exports